import { useState } from 'react';

import { useTranslation } from '@crehana/i18n';
import { useRouter } from 'next/router';

import { ReportsEnum } from '@/shared/types/graphql/globals.v5';
import { useAnalyticsReport } from '@/views/AdminDashboard/hooks/use-analytics-report';

const useReportRoute = () => {
  const { query } = useRouter();
  const { t } = useTranslation();

  const { slug } = query as { slug: string };

  const [reportDownloadDialog, setReportDownloadDialog] = useState(false);
  const { submitReport: sendAnalyticsReport } = useAnalyticsReport(slug);

  const sendReport = async () => {
    const success = await sendAnalyticsReport({
      name: t('REPORT_5_TITLE'),
      description: t('REPORT_5_DESCRIPTION'),
      report_type: ReportsEnum.REPORT_B2B_TRACKS,
    });

    if (success) {
      setReportDownloadDialog(true);
    }
  };

  return {
    sendReport,
    setReportDownloadDialog,
    reportDownloadDialog,
  };
};

export default useReportRoute;
